<template>
	<div class="container">
		<stockTopMenu windowId="deptStock" module="stock">
			<div slot="descript" class="row" style="margin-left: 300px;">
				<div class="row align-center cursor tab-item" style="margin-left: 100px;"
					 @click="$router.push('/deptStock');">
					<p>
						<img src="@/assets/images/tabIcon/start.png"
							 style="width:18px;height:18px;margin-right: 10px;float: left;margin-top: 2px;">
						<span>{{$t('deptStock.startInventory')}}</span>
					</p>
				</div>
				<div class="row align-center cursor tab-item"
					 style="margin-left: 100px;color: #067CF2;border-bottom: 4px solid #067CF2;margin-top: 20px;">
					<p style="padding-bottom: 15px;">
						<img src="@/assets/images/tabIcon/record-select.png"
							 style="width:18px;height:18px;margin-right: 10px;float: left;margin-top: 2px;">
						<span>{{$t('stockRecord.inventoryRecord')}}</span>
					</p>
				</div>
			</div>
		</stockTopMenu>
		<searchForm :options="options" @searchHandel="searchHandel"></searchForm>
		<section class="record-main"
				 v-loading="loading"
				 :element-loading-text="$t('stockRecord.loadingText')"
				 element-loading-spinner="el-icon-loading">
			<div class="record-table">
				<grid-manager
					v-if="gridOption && gridOption.ajaxData"
					ref="grid"
					:option="gridOption"
				></grid-manager>
			</div>
		</section>
		<multiWindow
			@close="closeDialog"
			ref="multiWindowRef"
			:moduleList="moduleList"
			:hasAdd="hasAdd"
			@hasAddChange="hasAddChange"
		></multiWindow>
		<singleRediscVue v-if="singleReSetDialog" ref="singleReSetRef" :modalParams="modalParams"
						 @close="close"></singleRediscVue>
	</div>
</template>

<script>
import {changeRecordState, queryDeptInventory} from '@/libs/http/modules/stock'
import stockTopMenu from "@/components/stockTopMenu.vue"
import searchForm from "@/components/searchForm.vue"
import multiWindow from '@/components/multiWindow/index.vue'
import {dialogConfig} from './../components/dialogConfig'
import {differConfig} from './../components/differConfig'
import {differDetail} from '../components/differDetailConfig.js'
import singleRediscVue from './components/singleRedisc.vue'

export default {
	components: {
		stockTopMenu,
		searchForm,
		singleRediscVue,
		multiWindow
	},
	data() {
		return {
			options: {
				searchItem: [
					{
						id: '1',
						type: 'input',
						size: 'small',
						clearable: true,
						placeholder: this.$t('stockRecord.placeholderSerialNumber'),
						label: this.$t('stockRecord.serialNumber'),
						value: '',
						resField: 'serialNumber'
					},
					{
						id: '2',
						type: 'input',
						size: 'small',
						clearable: true,
						placeholder: this.$t('stockRecord.placeholderSerialName'),
						label: this.$t('stockRecord.serialName'),
						value: '',
						resField: 'serialName'
					},
					{
						id: '3',
						type: 'daterange',
						size: 'small',
						clearable: true,
						placeholder: this.$t('stockRecord.placeholderCreateTime'),
						label: this.$t('stockRecord.createTime'),
						value: '',
						resField: 'createTime'
					},
					{
						id: '4',
						type: 'input',
						size: 'small',
						clearable: true,
						placeholder: this.$t('stockRecord.placeholderUserName'),
						label: this.$t('stockRecord.userName'),
						value: '',
						resField: 'userName'
					},
          {
            id: 'mode',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockRecord.placeholderSelect'),
            label: this.$t('stockRecord.mode'),
            value: '',
            resField: 'mode',
            list: [
              { name: this.$t('stockRecord.modeScan'), value: '1' },
              { name: this.$t('stockRecord.modeRfid'), value: '2' }
            ]
          },
					{
						id: '5',
						type: 'select',
						size: 'small',
						clearable: true,
						placeholder: this.$t('stockRecord.placeholderSelect'),
						label: this.$t('stockRecord.state'),
						value: '',
						resField: 'state',
						list: [
							{name: this.$t('stockRecord.inProgress'), value: '1'},
							{name: this.$t('stockRecord.invalid'), value: '2'},
							{name: this.$t('stockRecord.submitted'), value: '3'},
							{name: this.$t('stockRecord.reviewing'), value: '10'},
							{name: this.$t('stockRecord.posted'), value: '7'},
						]
					}
				],
				// 确认按钮
				sureBtnVisable: true,
				sureBtnType: 'primary',
				sureBtnSize: 'small',
				sureBtnText: this.$t('stockRecord.btnSearch'),
				//重置按钮
				restBtnVisable: true,
				restBtnType: '',
				restBtnSize: 'small',
				restBtnText: this.$t('stockRecord.btnReset'),
			},
			queryForm: {},
			loading: false,
			gridOption: {
				gridManagerName: "stock-record",
				supportAjaxPage: true,
				firstLoading: true,
				isCombSorting: false,
				supportCheckbox: false,
				supportAutoOrder: false,
				disableBorder: true,
				disableLine: true,
        i18n: this.$cache.local.get('locale') === 'vn' ? 'vn' : '',
				columnData: [
					{
						key: 'deptName',
						text: this.$t('stockRecord.deptName'),
						align: 'center',
						width: '120px'
					},
					{
						key: 'inventoryName',
						text: this.$t('stockRecord.inventoryName'),
						align: 'center',
						width: '250px'
					},
					{
						key: 'seq',
						text: this.$t('stockRecord.seq'),
						align: 'center',
						width: '150px'
					},
					{
						key: 'typeDesc',
						text: this.$t('stockRecord.typeDesc'),
						align: 'center'
					},
          {
            key: 'mode',
            text: this.$t('stockRecord.tableMode'),
            align: 'center',
            width: '100px',
            template: (row) => {
              return `
                <span>{{row.mode === '2' ? $t('stockRecord.modeRfid') : $t('stockRecord.modeScan')}}</span>
              `
            }
          },
					{
						key: 'stateDesc',
						text: this.$t('stockRecord.tableState'),
						align: 'center',
						width: '180px',
						template: (row) => {
							return `
                <span :style="{color: row.state === '1' ? '#067CF2' : row.state === '2' ? '#F8475F' : row.state === '3' ? '#43D268' : row.state === '7' ? '#BD73D3' : '#FF9000'}">{{row.stateDesc}}</span>
              `
						}
					},
					{
						key: 'userName',
						text: this.$t('stockRecord.userName'),
						width: '120px',
						align: 'center'
					},
					{
						key: 'createTime',
						text: this.$t('stockRecord.createTime'),
						align: 'center',
						width: '180px'
					},
					{
						key: 'finishTime',
						text: this.$t('stockRecord.finishTime'),
						align: 'center',
						width: '180px'
					},
					{
						key: 'reviewTime',
						text: this.$t('stockRecord.reviewTime'),
						align: 'center',
						width: '180px'
					},
					{
						key: 'detailCount',
						text: this.$t('stockRecord.detailCount'),
						align: 'center'
					},
					{
						key: 'goodsNoCount',
						text: this.$t('stockRecord.goodsNoCount'),
						align: 'center'
					},
					{
						key: 'goodsCount',
						text: this.$t('stockRecord.goodsCount'),
						align: 'center'
					},
					{
						key: 'unrecognizedCount',
						text: this.$t('stockRecord.unrecognizedCount'),
						align: 'center'
					},
					{
						key: "action",
						text: this.$t('stockRecord.tableAction'),
						width: "350px",
						align: "center",
						fixed: "right",
						template: () => {
							return `
                <el-button v-if="['1', '3'].includes(row.state)" size="mini" type="text" @click="changeState(row, '2')">{{$t('stockRecord.invalidate')}}</el-button>
                <el-button v-if="row.state === '2'" size="mini" type="text" @click="changeState(row, '8')">{{$t('stockRecord.restore')}}</el-button>
                <el-button v-if="row.state === '3' && row.mode !== '2'" size="mini" type="text" @click="ReSetOne(row)">{{$t('stockRecord.resetOne')}}</el-button>
                <el-button v-if="row.state === '1'" size="mini" type="text" @click="changeState(row, '3')">{{$t('stockRecord.finish')}}</el-button>
                <el-button v-if="row.state === '7'" size="mini" type="text" @click="showDifferDetail(row)">{{$t('stockRecord.diffDetail')}}</el-button>
                <el-button v-if="['3', '10', '7'].includes(row.state)" size="mini" type="text" @click="showDiffer(row)">{{$t('stockRecord.compareDiff')}}</el-button>
                <el-button size="mini" type="text" @click="showDetail(row)">{{$t('stockRecord.viewDetail')}}</el-button>
              `;
						},
					},
				],
				dataKey: 'items',
				totalsKey: 'totalItem',
				ajaxData: this.fetch,
				ajaxError: this.ajaxError
			},
			modalParams: null,
			singleReSetDialog: false,
			differConfig,
			dialogConfig,
			differDetail,
			moduleList: [], //存放最小化列表
			hasAdd: 'N', //判断是否有新增
		};
	},
  created() {
    document.title = this.$t('stockRecord.inventoryRecord')
  },
	methods: {
		searchHandel(e) {
			this.queryForm = e;
			GridManager.refreshGrid(this.gridOption.gridManagerName);
		},
		fetch(params) {
			let reqData = {
				serialNumber: this.queryForm['serialNumber'],
				name: this.queryForm['serialName'],
				userName: this.queryForm['userName'],
				state: this.queryForm['state'],
        mode: this.queryForm['mode'],
				page: params.pageData.cPage,
				pageSize: params.pageData.pSize,
				deptIdList: [this.$cache.local.get('deptId')]
			}
			if (this.queryForm && this.queryForm.createTime) {
				reqData['createStartTime'] = this.queryForm.createTime[0]
				reqData['createEndTime'] = this.queryForm.createTime[1]
			}
			return queryDeptInventory(reqData);
		},
		ajaxError(e) {
			this.$message({type: 'error', message: e, duration: 2000, showClose: true})
		},
		changeState(row, type) {
			let str = "";
			if (type == 2) {
				str = this.$t('stockRecord.invalidate')
			}
			if (type == 3) {
				str = this.$t('stockRecord.finish')
			}
			if (type == 8) {
				str = this.$t('stockRecord.confirmRestore')
			}
			this.$confirm(str, this.$t('stockDetail.confirmTitle')).then(() => {
					this.loading = true;
					changeRecordState({
						seq: row.seq,
						state: type
					}).then(data => {
						this.$message({type: 'success', message: this.$t('stockRecord.messageSuccess'), duration: 2000, showClose: true})
						GridManager.refreshGrid(this.gridOption.gridManagerName);
						this.loading = false;
					}).catch(error => {
						this.loading = false;
						this.$message({type: 'error', message: error, duration: 2000, showClose: true})
					})
				})
				.catch(() => {
				});
		},
		showDetail(row) {
			let arrId = this.moduleList.map(item => {
				return item.id
			})
			if (row && !arrId.includes(row?.id)) {
				this.moduleList.push(this.dialogConfig.detailsDialog(row))
			}
			//如果已经打开就把最小化的恢复到正常
			if (arrId.includes(row?.id)) {
				for (let ele of this.moduleList) {
					if (ele.id == row.id) {
						this.$refs['multiWindowRef'].unfoldTag(ele)
					}
				}
			}
		},
		showDiffer(row) {
			let arrId = this.moduleList.map(item => {
				return item.id
			})
			if (row && !arrId.includes(row?.id)) {
				this.moduleList.push(this.differConfig.detailsDialog(row))
			}
			//如果已经打开就把最小化的恢复到正常
			if (arrId.includes(row?.id)) {
				for (let ele of this.moduleList) {
					if (ele.id == row.id) {
						this.$refs['multiWindowRef'].unfoldTag(ele)
					}
				}
			}
		},
		
		showDifferDetail(row) {
			let arrId = this.moduleList.map(item => {
				return item.id
			})
			if (row && !arrId.includes(row?.id)) {
				this.moduleList.push(this.differDetail.detailsDialog(row))
			}
			//如果已经打开就把最小化的恢复到正常
			if (arrId.includes(row?.id)) {
				for (let ele of this.moduleList) {
					if (ele.id == row.id) {
						this.$refs['multiWindowRef'].unfoldTag(ele)
					}
				}
			}
		},
		
		//单款重盘
		ReSetOne(row) {
			this.modalParams = row
			this.singleReSetDialog = true
		},
		//关闭单款重盘
		close(e) {
			this.singleReSetDialog = false
			if (e) {
				GridManager.refreshGrid(this.gridOption.gridManagerName);
			}
		},
		closeDialog(e, type) {
			this.moduleList.forEach(item => {
				if (item.id == e[1]?.id) {
					item.isminimize = true
				}
				if (!e[1] && item.id == '-1') {
					item.isminimize = true
				}
			})
			if (e[0] && e[0] !== 'close') {
				GridManager.refreshGrid(this.gridOption.gridManagerName, true)
			}
			if (e[0] === 'close' || e[0]) {
				this.$refs['multiWindowRef'].closeTag(e[1])
			}
		},
		hasAddChange(e) {
			this.hasAdd = e
		}
	},
};
</script>

<style lang="scss" scoped>
.container {
	height: 100vh;
	overflow: hidden;
}

.record-main {
	padding: 0 10px 10px;
	width: 100%;
	.record-table {
		height: calc(100vh - 180px);
    padding: 0 10px;
		background: #fff;
		box-sizing: border-box;
	}
}
</style>
<style>
[grid-manager-mock-thead] {
	background: #F5F7FA !important;
}

[gm-overflow-x="true"] [grid-manager-mock-thead] [fixed]:last-child:after {
	background: #F5F7FA;
}

[gm-overflow-x="true"] [grid-manager-mock-thead] [fixed] {
	background: #F5F7FA;
}

.table-wrap .table-header {
	background: #F5F7FA;
}

.record-table .table-wrap {
	height: calc(100vh - 230px) !important;
}
</style>